import React from 'react';
import GraduationDay2023 from 'views/GraduationDay2023'

const SchoolProgrampage = () => {
  return <GraduationDay2023 />;
};

export default SchoolProgrampage;